var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "show-close": false,
            visible: _vm.isShowHint,
            center: "",
            title: "提示",
            top: "35vh",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowHint = $event
            },
          },
        },
        [
          _c("div", { staticClass: "u-m-t-20 u-m-b-20" }, [
            _vm._v("\n\t\t\t我已知晓：本保单\n\t\t\t"),
            _c("span", { staticClass: "red-bold" }, [
              _vm._v("仅承保施工地址在广东省内的工程项目"),
            ]),
            _vm._v(
              "\n\t\t\t。如施工地址在广东省外，保险人不承担任何赔偿责任。\n\t\t"
            ),
          ]),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "u-m-r-20",
                  attrs: { plain: "", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onHaveAccount(0)
                    },
                  },
                },
                [_vm._v("\n\t\t\t\t谢谢，投/被保险人不同意此告知。\n\t\t\t")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "u-m-l-20",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onHaveAccount(1)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t已知悉，我已告知投/被保险人，并取得投/被保险人的同意。\n\t\t\t"
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }